// Tile dimensions
export const TILE_HEIGHT_WEB = 108;
export const TILE_HEIGHT_PHONE = 216;
export const TILE_MARGIN_BOTTOM = 12;

// Image
export const IMAGE_WIDTH = 156;
export const IMAGE_HEIGHT = 104;
export const IMAGE_CONTAINER_WIDTH = 160;
export const IMAGE_CONTAINER_HEIGHT = 108;
export const IMAGE_CONTAINER_PADDING = 2;

// Layout
export const LINE_HEIGHT = 28;
export const HEADER_IMAGE_TEXT_GAP = 16;
export const BASE_LINE_WIDTH = 235;
export const SECTION_MARGIN_LEFT = 15;
export const SECTION_MARGIN_TOP = 18;

// Progress bar
export const PROGRESS_BAR_HEIGHT = 4;
export const PROGRESS_BAR_RADIUS = 3;

// Action button
export const ACTION_BUTTON_SIZE = 56;
export const ACTION_BUTTON_LABEL_TOP = 58;
export const ACTION_BUTTON_MARGIN_LEFT = 27;

// Badge
export const BADGE_BORDER_RADIUS = 12;
export const BADGE_MIN_WIDTH = 24;
export const BADGE_PADDING_VERTICAL = 2;
export const BADGE_PADDING_HORIZONTAL = 8;

// Modal
export const START_JOB_MODAL_WIDTH = 730;
